import gql from 'graphql-tag'

export const UPLOAD_CONTACTS = gql`
  mutation CreateContacts($contactArray: ContactArrayInput!){
    createContacts(contactArrayInput:$contactArray){
      contacts{
        id
        number
        name
        lastName      
      }
    }
  }
`

export const UPDATE_CONTACT = gql`
  mutation UpdateContact($contactData: ContactUpdateInput!){
    updateContact(contactData: $contactData){
      contact{
        id
        number
        name
        lastName
        facebookUrl
        instagramUrl
        avatarImg
        birthyear
        gender
        description
        hasInbox
        hasUnread
        bdayTags {
          id
          intValue
          strValue
          name
        }
        categorySet {
          id
          name
        }
        groupSet {
          id
          name
        }
        profileWorkHistory{
          id
          organization{
            id
            name
          }
          title{
            id
            name
          }
        }     
      }
    }
  }
`

export const UPLOAD_CONTACT_AVATAR = gql`
  mutation UploadContactAvatarImg($id: String!, $file: Upload!){
    uploadContactAvatarImg(uploadData: {id: $id, file: $file}){
      contact{
        id  
        avatarImg
      }
      success
    }
  }
`

export const UPLOAD_CONTACT_MEDIA = gql`
  mutation UploadContactMedia($id: String!, $file: Upload!){
    uploadContactMedia(uploadData: {id: $id, file: $file}){
      mediaUrl
      success
    }
  }
`
